var render = function render(_c,_vm){return _vm._m(0)
}
var staticRenderFns = [function (_c,_vm){return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"dots"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')]),_c('span',{staticClass:"loading-text"},[_vm._v("Loading Gist")])])
}]

export { render, staticRenderFns }